export const generateSelectYears = (params = {}) => {
  const {
    numberOfYears = 1,
    initialYear: initialDate = new Date(),
    inverse = false,
  } = params;

  const initialYear = initialDate.getFullYear();

  const getArrayOfYears = (_, i) => {
    const index = i + 1;
    return inverse ? initialYear - index : initialYear + index;
  };

  const years = Array.from({ length: numberOfYears }, getArrayOfYears);

  return [initialYear, ...years];
};

export const fixDate = (date = null) => {
  if (!date) return null;

  const _date = date.split('-');
  const day = +_date[0] > 9 ? _date[0] : `0${_date[0]}`;
  const month = +_date[1] > 9 ? _date[1] : `0${_date[1]}`;
  const year = +_date[2];
  
  return `${year}-${month}-${day}`;
};
